const SET_RIGHTHOLDER_STATEMENTS = "SET_RIGHTHOLDER_STATEMENTS";
const CLEAR_RIGHTHOLDER_STATEMENTS = "CLEAR_RIGHTHOLDER_STATEMENTS";
const SET_RIGHTHOLDER_FOR_FINANCE_ADMIN = "SET_RIGHTHOLDER_FOR_FINANCE_ADMIN";

export default {
  SET_RIGHTHOLDER_STATEMENTS,
  CLEAR_RIGHTHOLDER_STATEMENTS,
  SET_RIGHTHOLDER_FOR_FINANCE_ADMIN,
};
